import { gql } from "@apollo/client";import { useMutation } from "@apollo/client/react";import React, { useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';

import toast, { Toaster } from 'react-hot-toast';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import DetalleNotificaciones from './DetalleNotificaciones';
import Divider from '@mui/material/Divider';
import { CustomButton } from '../../../components/customButton/CustomButton';


export default function ConfigNotificaciones({ data }) {

  const navigate = useNavigate();
  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  const [listConfig, setListConfig] = useState([]);

  useEffect(() => {
    data.tipoNotificacionesUsuario.valorEsperado.map((item, index) => {
      setListConfig((prevState) => [...prevState,
      {
        idUsuario: idUsuario,
        idNotificacionTipo: item.idNotificacionTipo,
        email: item.email,
        push: item.push,
        obligatorio: item.obligatorio
      }]);
    });
  }, []);

  const MSaveNotificacionConfiguracion = gql`
    mutation MSaveNotificacionConfiguracion ($configuraciones: [NotificacionTipoUsuarioModelInput!]!) {
      saveNotificacionConfiguracion(configuraciones: $configuraciones)
      {
        success, 
        error,
        valorEsperado
      }
    }`;

  const [saveNotificacion, { loading, error, datos }] = useMutation(MSaveNotificacionConfiguracion, {
    onCompleted: (datos) => {
      if (datos.saveNotificacionConfiguracion.success) {
        if (datos.saveNotificacionConfiguracion.valorEsperado) {
          toast.success("Se grabaron las notificaciones");
          setTimeout(() => {
            navigate('/menu');
          }, 2000);
        } else {
          toast.error(datos.changePasswordById.error);
        }
      } else if (datos.saveNotificacionConfiguracion.error === 'ERRORDB' || parseInt(data.saveNotificacionConfiguracion.error, 10) > 0) {
        //setMensajeError(data.saveNotificacionConfiguracion.error);
        return false;
      }
    },
    onError: (datos) => {
      //setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleClick = () => {
    const found = listConfig.find((x) => x.obligatorio && !x.email && !x.push);

    if (found) {
      let notificacion = data.tipoNotificacionesUsuario.valorEsperado.find((y) => y.idNotificacionTipo === found.idNotificacionTipo);
      toast.error(`La notificacion ${notificacion.titulo} es obligatoria. Debe chequear algunas de las opciones.`);
    } else
    {
      let result = saveNotificacion({ variables: { configuraciones: listConfig } });
    }
  };

  return (
    <>
         <div style={{ paddingTop: "30px" }}>
      {
        data.tipoNotificacionesUsuario.valorEsperado.map((item) => item.nombre).
        filter((value, index, self) => self.indexOf(value) === index).map((item, index) => {
          return <>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                
                     <Typography style={{ fontWeight: 'bold', color: 'black', width: '100%', fontStyle: 'italic' }}>
                        <span>{item}
                        </span>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Divider style={{ position: 'relative', top: '-15px' }} />
                  <div style={{ float: 'right', display: 'flex' }}>
                    <InputLabel style={{ fontWeight: 'bold' }}><MailIcon /></InputLabel>   
                    <InputLabel style={{ fontWeight: 'bold', marginLeft: '20px', marginRight: '10px' }}><NotificationsIcon /></InputLabel>  
                  </div>
                  <div>
                    <DetalleNotificaciones rows={data.tipoNotificacionesUsuario.valorEsperado.filter((f) => f.nombre === item)} listConfig={listConfig} setListConfig={setListConfig} />                    
                  </div>
                </AccordionDetails>
            </Accordion>
            
            </>;
        })
        }
          </div>
         <br /><br /><br />
          <div className='section-content'>
            <CustomButton
          variant="contained"
          size="small"
          onClick={handleClick}
          style={{ float: 'right' }}
          endIcon={<SaveIcon />}>
          Guardar</CustomButton>  
          </div>

                
      </>);



};